var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullscreenFrontageDialog',{ref:"upgradeDialog",scopedSlots:_vm._u([{key:"default",fn:function(dialogProps){return [_c('UpgradePopUp',{attrs:{"upgradeName":dialogProps.upgradeName},on:{"onCancelClicked":_vm.handleClose,"onOkClicked":_vm.handleSubmit}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }